import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FilterPills from "@ucs/Components/SavedOrderList/FilterPills";
import * as React from "react";


const SavedOrderListFilterPills = ({ id }: WidgetProps) => {
    return (
        <FilterPills  />
    );
}


const widgetModule: WidgetModule = {
    component: SavedOrderListFilterPills,
    definition: {
        group: "Saved Order List",
        displayName: "Search Results Filter Pills",
        allowedContexts: ["SavedOrderListPage"],
        isSystem: true,
    },
};

export default widgetModule;